import AgencyIntegration from "@/components/agency-integration";

export default function AgencyIntegrationPage() {
  return <AgencyIntegration />;
}
